module.exports = __webpack_public_path__ + "9043d4aa72acde71cbc38744cec21931.png";